import Vue from 'vue'

export default {
  getNormativeActs ({ commit }) {
    return Vue.axios.get(`/about/normative-acts`)
    .then(({ data }) => commit('ADD_NORMATIVE_ACTS', data))
  },
  addNormativeAct ({ commit }) {
    return Vue.axios.post(`/about/normative-acts`)
    .then(({ data }) => commit('ADD_NEW_NORMATIVE_ACT', data))
  },
  deleteNormativeAct ({ commit }, id) {
    return Vue.axios.delete(`/about/normative-acts/${id}`)
    .then(() => commit('DELETE_NORMATIVE_ACT', id))
  },
  updateNormativeAct ({ commit }, document) {
    return Vue.axios.put(`/about/normative-acts`, { document })
  },
  updateAllNormativeActs ({ commit }, documents) {
    commit('ADD_NORMATIVE_ACTS', documents)
    return Vue.axios.put(`/about/normative-acts`, { documents })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/normativeActs.js